<template>
  <div class="content " v-loading.fullscreen.lock="fullscreenLoading">
    <div class="tab-wrap">
      <el-tabs v-model="page.listType" @tab-click="filterFlow">
        <el-tab-pane label="全部流程" name="0"> </el-tab-pane>
        <el-tab-pane label="待处理" name="4"></el-tab-pane>
        <el-tab-pane label="已处理" name="2"></el-tab-pane>
        <el-tab-pane label="我收到的" name="3"></el-tab-pane>
        <el-tab-pane label="我发起的" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="search-area" style="padding-top:0;">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">合同名称：</div>
          <el-input v-model="page.contractName" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="8"
          ><div class="search-area-div">审批状态：</div>
          <el-select size="mini" filterable clearable v-model="page.approveState" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in approveStateOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8"
          ><el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
        >
      </el-row>
    </div> -->
    <div class="search-area" style="padding-top:0;">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">合同名称：</div>
          <el-input size="mini" v-model="page.contractName" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">甲方名称：</div>
          <el-select size="mini" filterable clearable v-model="page.tenantGuid" class="ipt-sty" placeholder="请选择">
            <el-option
              v-for="item in tenantList"
              :key="item.tenantGuid"
              :label="item.tenantName"
              :value="item.tenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">乙方名称：</div>
          <el-select size="mini" filterable clearable v-model="page.serviceTenantGuid" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
        >
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">提交人：</div>
          <el-input size="mini" v-model="page.staffName" clearable class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审批状态：</div>
          <el-select size="mini" filterable clearable v-model="page.approveState" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in approveStateOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        
        <!-- <el-col  :span="6"
          ><el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
        > -->
      </el-row>
    </div>
   
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" >
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addContract">维护签约任务</el-button>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="tableHeight">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
     
    
        <el-table-column
          prop="tenantName"
          label="甲方名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="200"
          fixed="left"
        >
          <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="乙方名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="210"
          fixed="left"
        >
          <template slot-scope="scope">{{ scope.row.serviceTenantName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="enterpriseCate"
          label="公司类型"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.enterpriseCate | commonFilterName('平台企业类型') }}</template>
        </el-table-column>
        <el-table-column
          prop="signDate"
          label="申请时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column
          prop="contractContent"
          label="合同内容"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.contractContent | commonFilterName('合同内容分类') }}</template>
        </el-table-column>
        <el-table-column prop="endTime" label="审批状态" header-align="center" align="center" width="80">
          <template slot-scope="scope"
            ><span :class="getStateShow(scope.row.approveState)">{{
              scope.row.approveState | approveState
            }}</span></template
          >
        </el-table-column>
        <el-table-column prop="contractYear" label="提交人" header-align="center" align="left" width="120">
          <template slot-scope="scope">{{ scope.row.staffName }}</template>
        </el-table-column>
        <el-table-column
          prop="contractType"
          label="盖章合同"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.isUploadContract=='Y'?'已上传':'未上传'}}</template>
        </el-table-column>
        <el-table-column
          prop="contractName"
          label="合同名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="200"
       
        >
          <template slot-scope="scope">{{ scope.row.contractName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="contractCode"
          label="合同编码"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="160"
        >
        <template slot-scope="scope">{{ scope.row.contractCode || '-' }}</template>
        </el-table-column>
        <el-table-column prop="startTime" label="操作时间" header-align="center" align="left" width="140">
          <template slot-scope="scope">{{ scope.row.updateTime | getTime }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="200" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <a
              class="txt-color"
              v-if="
                getListBtnState('detail',scope.row) == 'detail'
              "
              @click="editContract(scope.row,2)"
              > 详情 </a
            >
            <a
              class="txt-color"
              @click="passDialogVisible=true;approveSuggest='';form=scope.row;"
              v-if="getListBtnState('approval',scope.row) == 'approval'"
              > 通过 
            </a>
            <a
              class="txt-color"
              @click="rejectDialogVisible=true;approveSuggest='';form=scope.row;"
              v-if="getListBtnState('approval',scope.row) == 'approval'"
              > 驳回 
            </a>
            <a
              class="txt-color"
              @click="toRevoke(scope.row)"
              v-if="getListBtnState('revoke',scope.row) == 'revoke'"
              >  撤销
            </a>
            <a
              class="txt-color"
              @click="editContract(scope.row,1)"
              v-if="
                getListBtnState('edit',scope.row) == 'edit'
              "
              > 编辑 
            </a>
            <a
              class="txt-color"
              v-if="
                getListBtnState('del',scope.row) == 'del'
              "
              @click="delContract(scope.row.guid)"
              >  删除 
            </a>
           
            <a
              class="txt-color"
              v-if="getListBtnState('again',scope.row) == 'again'"
              @click="editContract(scope.row,3)"
              >  重新提交 </a
            >
             
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import workFlowCommon from '@/uilt/workFlowCommon';
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 310,
      contentMainHeight: window.innerHeight - 210,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      flowType:'00011',
      fullscreenLoading: false,
      currentStaffGuid: null,
      tenantList: [], //甲方
      serviceTenantList: [], //乙方
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '', //甲方
        serviceTenantGuid: '', //乙方
        staffGuid: '',
        staffName: '',//提交人
        contractName: '',//合同
        approveState: null,//审批状态
        currentTenantGuid:localStorage.guid,
        listType: "0",
      },
      approveStateOption: [
        { label: '全部', value: null },
        { label: '草稿中', value: 'N' },
        { label: '审批中', value: 'A' },
        { label: '已通过', value: 'Y' },
        { label: '已驳回', value: 'R' },
        { label: '已撤销', value: 'C' },
      ],
      tableLoading: false,
      tableData: [],
      // height: window.innerHeight - 400,
      right: 'right',
      approveSuggest:'',
      passDialogVisible:false,
      rejectDialogVisible:false,
      form:'',
    };
  },
  watch:{
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 360;
        this.contentMainHeight = window.innerHeight - 260;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 310;
        this.contentMainHeight = window.innerHeight - 210;
        return;
      }
    
    },
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.getList(1);
    this.getTenantList();
    this.getServiceTenantList();
  },
  activated(){
    this.getList();
  },
  methods: {
    filterFlow(){
      this.getList();
    },
    //获取操作按钮显隐
    getListBtnState(btnType,row) {
      return workFlowCommon.getListBtnState(btnType,row.approveState, row.staffGuid, row.approveStaffGuids, this.currentStaffGuid,row.bizApproveState);
    },
    //获取审批状态
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },
    //新增
    addContract() {
      this.$router.push('/contractSealAdd?productGuid='+this.$route.query.productGuid);
    },
    //获取客户
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        approveState: 'Y',
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/projectApply/list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取乙方
    getServiceTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901', '9903', '9904'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //清空
    emptySearch() {
      this.page = {
        listType: "0",
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '', //甲方
        serviceTenantGuid: '', //乙方
        staffGuid: '',
        contractName: '',
        approveState: null,
        currentTenantGuid:localStorage.guid,
      };
      this.getList(1);
    },
    //type 为1编辑3重新提交 2为详情
    editContract(row,type) {
      let query = {
        guid: row.guid,
        approveStaffGuid: Array.isArray(row.approveStaffGuids) ? [row.approveStaffGuids] : null,
        camundaInstanceId: row.camundaInstanceId,
        camundaDeploymentId: row.camundaDeploymentId,
        tenantGuid: row.tenantGuid,
        submitStaffGuid: row.staffGuid,
        submitStaffName: row.staffName,
        toType:type,
        contractGuid:row.contractGuid,
        approveGuid:row.approveGuid,
        approveState:row.approveState,
        approveStateTask:row.approveStateTask,
        productGuid:this.$route.query.productGuid,
      };
      this.$router.push({
        path: (type == 1 || type == 3) ? '/contractSealAdd' : '/contractSealDetail',
        query,
      });
    },
    getList(type) {
      let self = this;
      if(type == 1){
        self.page.pageIndex = 1;
      }
      self.tableLoading = true;
      self.page.staffGuid = this.currentStaffGuid;
      self.api.postJson(`/${serverConfig.msCustomerService}/contract/get-contract-task-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 删除
    delContract(guid) {
      let self = this;
      self
        .$confirm(messageConfig.DELETE_AFTER, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msCustomerService}/contract/delete-contract-task`,[guid])
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success(messageConfig.DELETE_SUCCESS);
                self.page.pageIndex = 1;
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
    },
    //驳回提交
    toRejectSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.form.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success(messageConfig.FLOW_REJECT);
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.form.approveGuid,
        flowType: this.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success(messageConfig.FLOW_PASS);
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    //撤销
    toRevoke(form) {
      let self = this;
      this.$confirm(messageConfig.FLOW_IS_CANCEL, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let query = {
          guid: form.approveGuid,
          flowType: this.flowType,
          approveStaffGuid: form.staffGuid
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success(messageConfig.FLOW_CANCEL);
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.el-col-6{
  display: flex;
  /* margin-bottom: 10px; */
}
.search-area-div {
  width: 90px;
  text-align: right;
}
.ipt-sty{
  flex: 1;
}
a.txt-color +a.txt-color::before {
  content: "|";
  display: inline-block;
}
.tab-wrap {
  background: #fff;

}

/deep/ .el-tabs__nav {
  margin-left: 10px;
}
</style>
